import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/loading
 * @param {String} type - type for sucess/error/loading
 */

export const documentSuccess = (
  payload = {},
  type = types.FETCH_CREATE_DOCUMENT_SUCCESS
) => {
  return {
    type,
    payload
  };
};

export const documentLoading = (
  payload = {},
  type = types.LOADING_CREATE_DOCUMENT
) => {
  return {
    type,
    payload
  };
};
